type ResourceFields = {
  maxRssKb: number;
  userTimeUs: number;
  systemTimeUs: number;
};

export function peakMemoryBytes(result: ResourceFields): number {
  return result.maxRssKb * 1024;
}

export function cpuTimeMs(result: ResourceFields): number {
  return Math.round((result.userTimeUs + result.systemTimeUs) / 1000);
}

type NullableResourceFields = {
  maxRssKb: number | null;
  userTimeUs: number | null;
  systemTimeUs: number | null;
};

export function flattenResourceUsage<T extends NullableResourceFields>(
  row: T
): Omit<T, keyof NullableResourceFields> & {
  peakMemoryBytes: number | null;
  cpuTimeMs: number | null;
} {
  const { maxRssKb, userTimeUs, systemTimeUs, ...rest } = row;
  const present =
    maxRssKb !== null && userTimeUs !== null && systemTimeUs !== null;
  return {
    ...rest,
    peakMemoryBytes: present
      ? peakMemoryBytes({ maxRssKb, userTimeUs, systemTimeUs })
      : null,
    cpuTimeMs: present
      ? cpuTimeMs({ maxRssKb, userTimeUs, systemTimeUs })
      : null,
  };
}
